import request from '../helpers/request'

export default {
  repair_request: async (url, payload) => {
    const { data } = await request.post(url, payload)

    return data
  }
}
